import { GroupDefinitionZombie } from '@iotv/iotv-v3-types'

/** WTM Role Management */

const originalGroupDefinitions: GroupDefinitionZombie[] = [
  {
    id: 'Manager',
    displayName: 'Manager',
    precedence: 4,
    policies: ['systemManagementRoleAdditions', 'systemManagementApiPolicy'],
    inheritPoliciesNames: ['systemManagementDefintion'],
  },

  {
    id: 'Farmer',
    displayName: 'Farmer',
    precedence: 4,
    policies: ['systemManagementRoleAdditions', 'systemManagementApiPolicy'],
    inheritPoliciesNames: ['systemManagementDefintion'],
  },

  {
    id: 'FarmManager',
    displayName: 'Farm Manager',
    precedence: 4,
    policies: ['systemManagementRoleAdditions', 'systemManagementApiPolicy'],
    inheritPoliciesNames: ['systemManagementDefintion'],
  },

  {
    id: 'Installer',
    displayName: 'Installer',
    precedence: 10,
    policies: [],
    inheritPoliciesNames: ['userPolicyDefintion'],
  },

  {
    id: 'WaterEngineeringSpecialist',
    displayName: 'Water Engineering Specialist',
    precedence: 15,
    policies: [],
    inheritPoliciesNames: ['userPolicyDefintion'],
  },

  {
    id: 'FarmWorker',
    displayName: 'Farm Worker',
    precedence: 20,
    policies: ['deviceControllApiPolicy'],
    inheritPoliciesNames: ['userPolicyDefintion'],
  },
]

/** WTG Role Management */

const v3baseRoles: GroupDefinitionZombie[] = [
  {
    id: 'Admin',
    displayName: 'Admin',
    precedence: 4,
    policies: ['systemManagementRoleAdditions', 'systemManagementApiPolicy'],
    inheritPoliciesNames: ['systemManagementDefintion'],
  },

  {
    id: 'Farmer',
    displayName: 'Farmer',
    precedence: 4,
    policies: ['systemManagementRoleAdditions', 'systemManagementApiPolicy'],
    inheritPoliciesNames: ['systemManagementDefintion'],
  },

  {
    id: 'FarmManager',
    displayName: 'Farm Manager',
    precedence: 4,
    policies: ['systemManagementRoleAdditions', 'systemManagementApiPolicy'],
    inheritPoliciesNames: ['systemManagementDefintion'],
  },

  //  {
  //    id: 'Installer',
  //    displayName: 'Installer',
  //    precedence: 10,
  //    policies: [],
  //    inheritPoliciesNames: [ 'userPolicyDefintion' ]
  //  },

  //  {
  //    id: 'WaterEngineeringSpecialist',
  //    displayName: 'Water Engineering Specialist',
  //    precedence: 15,
  //    policies: [],
  //    inheritPoliciesNames: [ 'userPolicyDefintion']
  //  },

  {
    id: 'FarmWorker',
    displayName: 'Farm Worker',
    precedence: 20,
    policies: ['deviceControllApiPolicy'],
    inheritPoliciesNames: ['userPolicyDefintion'],
  },
]

let groupDefinitions: GroupDefinitionZombie[] = [...v3baseRoles, ...originalGroupDefinitions]
export { groupDefinitions }
